import { render } from "./cancel_message.vue?vue&type=template&id=6cf5f62e"
import script from "./cancel_message.vue?vue&type=script&lang=js"
export * from "./cancel_message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__